/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs
*/
// TODO - add HS code here. This file exists to keep other app bundle files from
// accessing the HS global object. (CC)
module.exports = global.HelloSign || {};
